import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconReceipt = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.25 1.875L9.375 0L7.5 1.875L5.625 0L3.75 1.875L0.9375 0V14.0625C0.9375 14.625 1.3125 15 1.875 15H13.125C13.6875 15 14.0625 14.625 14.0625 14.0625V0L11.25 1.875ZM11.25 11.25H3.75V9.375H11.25V11.25ZM11.25 7.5H3.75V5.625H11.25V7.5Z",
		fill: "currentColor"
	})
});
export default SvgIconReceipt;
